export default "__VITE_ASSET__CrwMqsf7__"